export class ProductCardImages extends HTMLElement {
  constructor() {
    super();

    if (theme.config.isTouch) {
      this.draggable = false;
    } else {
      this.draggable = true;
    }

    if (document.querySelector(".template-collection")) {
      this.dragThreshold = 40;
    } else {
      this.dragThreshold = 3;
    }
  }

  get container() {
    return this.closest(".product-card__media");
  }

  get prevButton() {
    return this.container.querySelector("[data-prev-button]");
  }

  get nextButton() {
    return this.container.querySelector("[data-next-button]");
  }

  connectedCallback() {
    if (this.innerHTML.trim().length) {
      if (this.classList.contains("flickity")) {
        this.carousel = new Flickity(
          this,
          {
            prevNextButtons: false,
            adaptiveHeight: false,
            pageDots: true,
            contain: true,
            cellAlign: "center",
            rightToLeft: theme.config.rtl,
            imagesLoaded: true,
            fade: true,
            wrapAround: true,
            setGallerySize: false,
            draggable: true,
            dragThreshold: this.dragThreshold,
          },
          {
            previous: this.prevButton,
            next: this.nextButton,
          },
        );
        this.handleActions();
      }
    } else {
      this.container.hidden = true;
    }
  }

  handleActions() {
    if (!theme.config.isTouch) {
      const productCard = this.closest(".product-card__media");
      handleHover(this.carousel, productCard);
    }

    let dirty = false;

    this.prevButton?.addEventListener(
      "click",
      (event) => {
        return this.carousel.next();
      },
      false,
    );

    this.nextButton?.addEventListener(
      "click",
      (event) => {
        dirty = true;
        return this.carousel.next();
      },
      false,
    );

    function handleHover(carousel, productCard) {
      productCard.addEventListener(
        "mouseenter",
        (event) => {
          return carousel.select(1);
        },
        false,
      );

      productCard.addEventListener(
        "mouseleave",
        (event) => {
          if (!dirty) return carousel.select(0);
        },
        false,
      );
    }
  }
}
customElements.define("product-card-images", ProductCardImages);
